import axios from 'axios'

export function createTargetGroup(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/target-groups', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getTargetGroups(spaceID, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/target-groups?page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function searchTargetGroups(spaceId, searchTerm) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/target-groups?page[size]=500&filter[keyword]=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getTargetGroup(tgId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/target-groups/' + tgId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function updateTargetGroup(tgId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/target-groups/' + tgId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function deleteTargetGroup(tgId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/target-groups/' + tgId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getTargetGroupUsers(tgId, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/target-groups/' + tgId + '/-actions/get-users?filter[regular-members]=true&page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getTargetGroupBoosters(tgId, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/target-groups/' + tgId + '/-actions/get-users?filter[boosters]=true&page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function addPeopleToTargetGroup(tgId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/target-groups/' + tgId + '/-actions/add-users', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}
export function addTargetGroupBoosters(tgId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/target-groups/' + tgId + '/-actions/add-boosters', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function removeUserFromTargetGroup(tgId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/target-groups/' + tgId + '/-actions/remove-user', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}